/* Winter 2027 - product page behaviour: savings, low stock, size guide, sticky add-to-cart */
(function () {
  if (window.__w27pdp) return;
  window.__w27pdp = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var offer = document.querySelector('[data-w27-offer]');
    var dataEl = document.querySelector('[data-w27-variants]');
    var variants = {};
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (v) { variants[v.id] = v; });
      } catch (e) {}
    }

    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    }

    /* ---- savings + low stock ---- */
    function updateOffer() {
      if (!offer) return;
      var v = variants[currentVariantId()];
      var save = offer.querySelector('[data-w27-save]');
      var stock = offer.querySelector('[data-w27-stock]');
      var currency = offer.getAttribute('data-currency') || '';
      var threshold = parseInt(offer.getAttribute('data-threshold'), 10) || 5;

      if (save) {
        if (v && v.compare > v.price) {
          var pct = Math.round(((v.compare - v.price) / v.compare) * 100);
          var amount = Math.round((v.compare - v.price) / 100);
          save.querySelector('[data-w27-pct]').textContent = '-' + pct + '%';
          save.querySelector('[data-w27-amount]').textContent = amount + ' ' + currency;
          save.hidden = false;
        } else {
          save.hidden = true;
        }
      }
      if (stock) {
        if (v && v.available && v.qty !== null && v.qty > 0 && v.qty <= threshold) {
          stock.textContent = (offer.getAttribute('data-low-label') || 'Only {n} left').replace('{n}', v.qty);
          stock.hidden = false;
        } else {
          stock.hidden = true;
        }
      }
    }

    /* ---- size guide link opens the Size Chart tab ---- */
    document.querySelectorAll('[data-w27-sizeguide]').forEach(function (link) {
      var target = null;
      document.querySelectorAll('details').forEach(function (d) {
        var s = d.querySelector('summary');
        if (!target && s && /size\s*chart|size\s*guide/i.test(s.textContent)) target = d;
      });
      if (!target) { link.hidden = true; return; }
      link.addEventListener('click', function (e) {
        e.preventDefault();
        target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---- sticky add-to-cart ---- */
    var bar = document.querySelector('[data-w27-sticky]');
    var mainBtn = document.querySelector('.product-form__submit');
    var sizeSelect = bar ? bar.querySelector('[data-w27-size]') : null;
    var barBtn = bar ? bar.querySelector('[data-w27-sticky-btn]') : null;
    var barPrice = bar ? bar.querySelector('[data-w27-price]') : null;
    var sizeFieldset = null;

    function findSizeFieldset() {
      var found = null;
      document.querySelectorAll('fieldset.product-form__input').forEach(function (f) {
        var legend = f.querySelector('legend');
        if (!found && legend && /size/i.test(legend.textContent) && f.querySelector('input[type="radio"]')) found = f;
      });
      return found;
    }

    function refreshBar() {
      if (!bar || !mainBtn) return;
      var priceEl = document.querySelector('.product__info-container .price');
      if (priceEl && barPrice) {
        var clone = priceEl.cloneNode(true);
        clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        barPrice.innerHTML = '';
        barPrice.appendChild(clone);
      }
      if (barBtn) {
        var label = mainBtn.querySelector('span');
        barBtn.textContent = (label ? label.textContent : mainBtn.textContent).trim();
        barBtn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      }
      if (sizeSelect && sizeFieldset) {
        var radios = sizeFieldset.querySelectorAll('input[type="radio"]');
        if (!sizeSelect.options.length) {
          radios.forEach(function (r) {
            var o = document.createElement('option');
            o.value = r.value;
            o.textContent = r.value;
            sizeSelect.appendChild(o);
          });
        }
        radios.forEach(function (r, i) {
          var o = sizeSelect.options[i];
          if (!o) return;
          o.disabled = r.classList.contains('disabled');
          if (r.checked) sizeSelect.value = r.value;
        });
        sizeSelect.hidden = false;
      }
    }

    if (bar && mainBtn) {
      document.body.appendChild(bar);
      sizeFieldset = findSizeFieldset();
      refreshBar();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }).observe(mainBtn);
      }

      if (barBtn) barBtn.addEventListener('click', function () { mainBtn.click(); });
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          if (!sizeFieldset) return;
          sizeFieldset.querySelectorAll('input[type="radio"]').forEach(function (r) {
            if (r.value === sizeSelect.value) r.click();
          });
        });
      }

      var info = document.querySelector('.product__info-container');
      if (info && 'MutationObserver' in window) {
        var t;
        new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(function () {
            sizeFieldset = sizeFieldset && document.contains(sizeFieldset) ? sizeFieldset : findSizeFieldset();
            mainBtn = document.querySelector('.product-form__submit') || mainBtn;
            refreshBar();
          }, 150);
        }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked', 'class', 'aria-disabled'] });
      }
    }

    /* ---- react to variant changes ---- */
    updateOffer();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id') setTimeout(updateOffer, 50);
      else if (t && t.closest && t.closest('variant-selects, variant-radios')) setTimeout(updateOffer, 700);
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(updateOffer, 50); });
    }
  });
})();
